import { render, staticRenderFns } from "./OrderLogs.vue?vue&type=template&id=276bdb7f&scoped=true"
import script from "./OrderLogs.vue?vue&type=script&lang=js"
export * from "./OrderLogs.vue?vue&type=script&lang=js"
import style0 from "./OrderLogs.vue?vue&type=style&index=0&id=276bdb7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276bdb7f",
  null
  
)

export default component.exports